import _extends from "@babel/runtime/helpers/esm/extends";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import Component from '../Component';
var FoveationLevel;

(function (FoveationLevel) {
  FoveationLevel[FoveationLevel["none"] = 0] = "none";
  FoveationLevel[FoveationLevel["low"] = 1] = "low";
  FoveationLevel[FoveationLevel["medium"] = 2] = "medium";
  FoveationLevel[FoveationLevel["high"] = 3] = "high";
})(FoveationLevel || (FoveationLevel = {}));

export var Renderer = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Renderer, _Component);

  function Renderer(props) {
    return _Component.call(this, _extends({}, props, {
      // @ts-ignore
      foveationLevel: props.foveationLevel === undefined ? props.foveationLevel : FoveationLevel[props.foveationLevel]
    })) || this;
  }

  return Renderer;
}(Component);